import {Pipe, PipeTransform} from '@angular/core';
import {DeviceType} from '../../afb-api/enums/device-type.enum';

@Pipe({
  name: 'deviceTypeNameFull'
})

export class DeviceTypeNameFullPipe implements PipeTransform {

  transform(value: DeviceType): string {
    const deviceTypeMap = {
      [DeviceType.Awair]: 'AWAIR',
      [DeviceType.Glow]: 'AWAIR Glow',
      [DeviceType.Mint]: 'AWAIR Mint',
      [DeviceType.Omni]: 'AWAIR Omni',
      [DeviceType.Rev2]: 'AWAIR Rev.2'
    };

    return deviceTypeMap[value];
  }
}
